import { render } from "./DuplicatedCustomerReferenceModal.vue?vue&type=template&id=2c37b9fa"
import script from "./DuplicatedCustomerReferenceModal.vue?vue&type=script&lang=js"
export * from "./DuplicatedCustomerReferenceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__